import React from 'react';
import PropTypes from 'prop-types';
import { Divider, makeStyles } from '@ellucian/react-design-system/core';
import { spacing80, fontWeightBold } from '@ellucian/react-design-system/core/styles/tokens';
const useStyles = makeStyles(() => ({
    divider: {
        width: spacing80,
    },
    root: {
        fontWeight: fontWeightBold,
    },
}));
const SectionLabel = props => {
    const classes = useStyles();
    const { children = null } = props;
    return (
        <div className={classes.root}>
            {children}
            <Divider classes={{ root: classes.divider }} />
        </div>
    );
};
SectionLabel.propTypes = {
    children: PropTypes.node,
};
export default SectionLabel;
